import arrayEach from 'fast-loops/lib/arrayEach';
import { RULE_TYPE } from 'fela-utils';

import rehydrateSupportRules from './rehydrateSupportRules';
import rehydrateRules from './rehydrateRules';

// rehydration (WIP)
// TODO: static, keyframe, font
export default function rehydrate(renderer) {
  arrayEach(document.querySelectorAll('[data-fela-type]'), function (node) {
    var rehydrationAttribute = node.getAttribute('data-fela-rehydration') || -1;
    var rehydrationIndex = renderer.uniqueRuleIdentifier || parseInt(rehydrationAttribute, 10);

    // skip rehydration if no rehydration index is set
    // this index is set to -1 if something blocks rehydration
    if (rehydrationIndex !== -1) {
      var type = node.getAttribute('data-fela-type') || '';
      var media = node.getAttribute('media') || '';
      var support = node.getAttribute('data-fela-support');
      var css = node.textContent;

      renderer.uniqueRuleIdentifier = rehydrationIndex;

      if (type === RULE_TYPE) {
        if (support) {
          rehydrateSupportRules(css, media, renderer.cache);
        } else {
          rehydrateRules(css, media, '', renderer.cache);
        }
      }
    }
  });

  renderer._emitChange({ type: 'REHYDRATATION_FINISHED' });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/rehydration/rehydrate.js
// module id = 164
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38